import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import "./plugins/element.js"
import store from "./store"
import axios from "axios"

import VueLocalStorage from "vue-localstorage"
Vue.use(VueLocalStorage)

Vue.config.productionTip = false

import Element from "element-ui"
import "element-ui/lib/theme-chalk/reset.css"
import "element-ui/lib/theme-chalk/index.css"
Vue.use(Element)

import "./admin.scss"

// the Historiana API
/* eslint-disable */
Vue.prototype.$API = axios.create({
  baseURL: `api/`,
  headers: {
    Authorization: "Bearer {token}",
  },
})

import _ from "lodash"
Vue.prototype._ = _

/* eslint-enable */

const app = new Vue({
  router,
  store,
  localStorage: {
    autologin: {
      type: Boolean,
      default: true,
    },
    session: {
      type: String,
      default: "", // do not use null, it becomes thruthy
    },
  },
  render: (h) => h(App),
}).$mount("#app")
